import React, { Component } from "react";
import { showMainErrorPop } from '../../actions/popups';
import { connect } from "react-redux";
import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class AccountSecurity extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		accountArray: []
    }
	
}
 
componentDidMount(){
	axiosVirdio = new axiosVirdioT(this.props);
	this.getSecuritySettings();
}

getSecuritySettings=()=>{
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/getUserSecurity").then(res => {
		this.setState({accountArray: res.data.responseData})
	}).catch(err =>{ });
}

updateStatus=(i)=>{
	var accArrayVar = this.state.accountArray;
	accArrayVar[i].status = !accArrayVar[i].status;
	this.setState({accountArray: accArrayVar}, () => this.updateSecurity());
}

updateSecurity=()=>{
	var accArrayVar = this.state.accountArray;
	var arrayToSend = [];
	for ( var i = 0; i < accArrayVar.length; i++ )
		{
			arrayToSend.push({id: accArrayVar[i].id, status: accArrayVar[i].status});
		}
		
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	var postData = { arraySecurity: JSON.stringify(arrayToSend) };
	axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/updateUserSecurity", postData).then(res => { }).catch(err =>{ });
}

  render() {
	 return (
		<div className="options_settins_content">
			{ this.state.accountArray.map((item, i) =>
				<div className="one_toggle_option" key={i}>
					<div className="title_toggle_option">{item.name}
						<div className="switch_check" onClick={() => this.updateStatus(i)}>
							<input type="checkbox" checked={item.status} />
							<span className="slider_filter round_filter"></span>
						</div>
					</div>
				</div>
			)}
		</div>
    );
  }
}
export default connect(
  null,
  { 
	showMainErrorPop
  }
)(AccountSecurity);
